import _ from "underscore";
import Immutable from "immutable";
import { underscored, words } from "underscore.string";
import { serverStaticUrl } from "../config";

export const Qualities = {
  1: "VERY LOW",
  2: "LOW",
  3: "MODERATE",
  4: "HIGH"
};

export const isDevEnv = () => process.env.NODE_ENV === "development";

export const isTestServer = () =>
  window.location.hostname === "gdt.test.evidenceprime.com";

export const logger = ({ getState }) => {
  return next => action => {
    console.log("will dispatch", action);
    console.log("state before dispatch", getState());
    // Call the next dispatch method in the middleware chain.
    const returnValue = next(action);
    console.log("state after dispatch", action.type, getState());
    // This will likely be the action itself, unless
    // a middleware further in chain changed it.
    return returnValue;
  };
};

export const normalizeValue = (value, min, max) =>
  parseInt(((value - min) * 100) / (max - min));

export const isJsonString = str => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const uncapitalizeExceptAllCaps = str => {
  var firstWord;
  firstWord = words(str)[0];
  if (firstWord.toUpperCase() === firstWord) {
    return str;
  } else {
    return str.charAt(0).toLowerCase() + str.slice(1);
  }
};

export const getSubchapterImageSrc = image =>
  _.isEmpty(image.customSrc)
    ? `${serverStaticUrl}/decision-aids/subchapter-illustrations/${underscored(
        image.illustration
      )}.svg`
    : image.customSrc;

export const outcomeWithData = metaType =>
  ["NOT_POOLED", "NOT_REPORTED", "NOT_MEASURED"].indexOf(metaType) === -1;

export const vancouverFormat = function(referenceData) {
  let value;
  let { authors, title } = referenceData;
  const addIfDefined = (field, separator) => {
    var fieldVal, ref;
    fieldVal = (ref = referenceData[field]) != null ? ref : "";
    if (fieldVal.length) {
      return ` ${fieldVal}${separator}`;
    } else {
      return "";
    }
  };
  authors = authors
    .map(function(author) {
      return `${author.lastName}, ${author.firstNames}`;
    })
    .join(", ");
  value = `${authors}. ${title}.`;
  value += addIfDefined("publishedIn", ";");
  value += addIfDefined("year", ".");
  return value;
};

export const getReferencesFromContent = function(editorContent) {
  if (!editorContent || _.isString(editorContent)) {
    return [];
  }
  const entities = editorContent.get("entityMap");
  return _.unique(
    editorContent.get("blocks").reduce(function(references, block) {
      const entityRanges = block.get("entityRanges");
      if (entityRanges.isEmpty()) {
        return references;
      }
      entityRanges.forEach(function(entityRange) {
        const entity = entities.get(`${entityRange.get("key")}`);
        if (entity.get("type") !== "REFERENCE") {
          return;
        }
        return (references = references.concat(
          _(entity.getIn(["data", "references"]).toJS()).toArray()
        ));
      });
      return references;
    }, [])
  );
};

export const findReferencesInChapter = (chapter, outcomes = {}) => {
  if (_.isEmpty(chapter.subchapters)) return [];
  return chapter.subchapters.reduce((acc, subchapter) => {
    if (subchapter.type === "editor") {
      return acc.concat(
        getReferencesFromContent(Immutable.fromJS(subchapter.content))
      );
    } else if (
      subchapter.type === "table" &&
      !_.isEmpty(subchapter.tableContent)
    ) {
      return acc.concat(
        subchapter.tableContent.columns.reduce((acc2, columns) => {
          return acc2.concat(
            getReferencesFromContent(Immutable.fromJS(columns.content))
          );
        }, [])
      );
    } else if (subchapter.type === "outcomesTable" && !_.isEmpty(outcomes)) {
      const outcomeTextContents = outcomes.map(outcome =>
        outcome.type === "narrative" ? outcome.narrativeDesc : outcome.comments
      );

      return outcomeTextContents.reduce((acc2, text) => {
        return acc2.concat(getReferencesFromContent(Immutable.fromJS(text)));
      }, []);
    } else return acc;
  }, []);
};

export const uniqueReferences = references =>
  _.unique(references, false, ref => {
    return ref._id;
  });
